
function handleSearch(search,mutationData){
    if (search) {
         return mutationData.filter(function (product) {
          // 每一项数据
          // console.log(product)
          return Object.keys(product).some(function (key) {
            // 每一项数据的参数名
            // console.log(key)
            return (
              String(product[key])
                // toLowerCase() 方法用于把字符串转换为小写。
                .toLowerCase()
                // indexOf() 方法可返回某个指定的字符串值在字符串中首次出现的位置。
                .indexOf(search.toLowerCase()) > -1
            );
          });
        });
        console.log(searchData)
      }else{
        return []
      }
 }
 module.exports =  {
    handleSearch,
 }